import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
@Component({
  selector: 'app-table-content',
  templateUrl: './table-content.component.html',
  styleUrls: ['./table-content.component.scss']
})
export class TableContent implements OnInit {

  @Input() dataReport: any
  type_create = null;
  constructor() {
    console.log(this.dataReport)
  }

  ngOnInit(): void {
  };

  ngOnChanges(changes: SimpleChanges) {
    this.mappingData()
  }

  mappingData() {
    if(this.dataReport && this.dataReport.data) {
      this.type_create = this.dataReport.data.type_create;
    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/table-content/table-content.component.ts